import React from 'react';
import { ThemeProvider } from 'styled-components';
import { darken, lighten } from 'polished';

const blacksAndGrays = {
  abbey: "#555757",
  alto: "#DFDFDF",
  black: "#000000",
  boulder: "#757575",
  capeCod: "#323535",
  codGray: "#121212",
  diesel: "#030001",
  dustyGray: "#999999",
  gallery: "#EEEEEE",
  gray: "#858585",
  mercury: "#E6E6E6",
  mineShaft: "#333333",
  nevada: "#6D6E71",
  quillGray: "#D3D3D2",
  shark: "#191A1C",
  silver: "#CCCCCC",
  silverChalice: "#A6A6A6",
  tundora: "#444444",
  white: "#FFFFFF"
};
const colors = { ...blacksAndGrays
};

const LIGHT_DARK_ALPHA$1 = 0.2;

const getColors = () => ({
  gray: {
    contrast: colors.white,
    dark: darken(LIGHT_DARK_ALPHA$1, colors.gray),
    light: lighten(LIGHT_DARK_ALPHA$1, colors.gray),
    main: colors.gray
  }
});

const LIGHT_DARK_ALPHA = 0.5;

const getDark = baseColorGrades => baseColorGrades.dark || darken(LIGHT_DARK_ALPHA, baseColorGrades.main);

const getLight = baseColorGrades => baseColorGrades.light || lighten(LIGHT_DARK_ALPHA, baseColorGrades.main);

const getPalette = theme => {
  const {
    palette: basePalette
  } = theme;
  const palette = {
    disabled: { ...basePalette.disabled,
      dark: getDark(basePalette.disabled),
      light: getLight(basePalette.disabled)
    },
    primary: { ...basePalette.primary,
      dark: getDark(basePalette.primary),
      light: getLight(basePalette.primary)
    },
    secondary: { ...basePalette.secondary,
      dark: getDark(basePalette.secondary),
      light: getLight(basePalette.secondary)
    },
    text: { ...basePalette.text,
      dark: getDark(basePalette.text),
      light: getLight(basePalette.text)
    }
  };
  return palette;
};

const getTheme = baseTheme => {
  // Palette
  const palette = getPalette(baseTheme); // Colors

  const colors = getColors();
  return { ...baseTheme,
    colors,
    palette
  };
};

const Provider = ({
  children,
  theme: baseTheme
}) => {
  const theme = getTheme(baseTheme);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};

export { Provider as P, colors as c };
